export default __webpack_public_path__ + "static/media/registergirl1.e018f968.gif";